const COMPACT_EVENT_MAX_DURATION_MS = 30 * 60 * 1000;

function formatCalendarTime(date: Date): string {
  return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

/** Start- und Endzeit für die unaufdringliche Vorschau beim Aufziehen einer neuen Session. */
export function formatCalendarSelectionTimes(
  start: Date | null,
  end: Date | null,
): { startTime: string; endTime: string } | null {
  if (!start || !end) return null;
  return {
    startTime: formatCalendarTime(start),
    endTime: formatCalendarTime(end),
  };
}

export function isCompactCalendarEvent(start: Date | null, end: Date | null): boolean {
  if (!start || !end) return false;
  return end.getTime() - start.getTime() <= COMPACT_EVENT_MAX_DURATION_MS;
}
